import { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const GoalNet = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M13.6 2.40002C14.9 2.40002 16 3.50002 16 4.80002V12.8C16 13.25 15.625 13.6 15.2 13.6C14.75 13.6 14.4 13.25 14.4 12.8V4.80002C14.4 4.37502 14.025 4.00002 13.6 4.00002H2.4C1.95 4.00002 1.6 4.37502 1.6 4.80002V12.8C1.6 13.25 1.225 13.6 0.8 13.6C0.35 13.6 0 13.25 0 12.8V4.80002C0 3.50002 1.075 2.40002 2.4 2.40002H13.6ZM13.2 7.20002H12V8.80002H13.2C13.4 8.80002 13.6 9.00002 13.6 9.20002C13.6 9.42502 13.4 9.60002 13.2 9.60002H12V11.2H13.2C13.4 11.2 13.6 11.4 13.6 11.6C13.6 11.825 13.4 12 13.2 12H12V13.2C12 13.425 11.8 13.6 11.6 13.6C11.375 13.6 11.2 13.425 11.2 13.2V12H9.6V13.2C9.6 13.425 9.4 13.6 9.2 13.6C8.975 13.6 8.8 13.425 8.8 13.2V12H7.2V13.2C7.2 13.425 7 13.6 6.8 13.6C6.575 13.6 6.4 13.425 6.4 13.2V12H4.8V13.2C4.8 13.425 4.6 13.6 4.4 13.6C4.175 13.6 4 13.425 4 13.2V12H2.8C2.575 12 2.4 11.825 2.4 11.6C2.4 11.4 2.575 11.2 2.8 11.2H4V9.60002H2.8C2.575 9.60002 2.4 9.42502 2.4 9.20002C2.4 9.00002 2.575 8.80002 2.8 8.80002H4V7.20002H2.8C2.575 7.20002 2.4 7.02502 2.4 6.80002C2.4 6.60002 2.575 6.40002 2.8 6.40002H4V5.20002C4 5.00002 4.175 4.80002 4.4 4.80002C4.6 4.80002 4.8 5.00002 4.8 5.20002V6.40002H6.4V5.20002C6.4 5.00002 6.575 4.80002 6.8 4.80002C7 4.80002 7.2 5.00002 7.2 5.20002V6.40002H8.8V5.20002C8.8 5.00002 8.975 4.80002 9.2 4.80002C9.4 4.80002 9.6 5.00002 9.6 5.20002V6.40002H11.2V5.20002C11.2 5.00002 11.375 4.80002 11.6 4.80002C11.8 4.80002 12 5.00002 12 5.20002V6.40002H13.2C13.4 6.40002 13.6 6.60002 13.6 6.80002C13.6 7.02502 13.4 7.20002 13.2 7.20002ZM6.4 11.2V9.60002H4.8V11.2H6.4ZM6.4 8.80002V7.20002H4.8V8.80002H6.4ZM8.8 11.2V9.60002H7.2V11.2H8.8ZM8.8 8.80002V7.20002H7.2V8.80002H8.8ZM11.2 11.2V9.60002H9.6V11.2H11.2ZM11.2 8.80002V7.20002H9.6V8.80002H11.2Z"
      fill="currentColor"
    />
  </svg>
);
